import React, { useEffect, useContext } from 'react'

import EventList from '../components/EventList'
import Section from '../components/Section'
import { PageLoaderContext } from '../contexts/PageLoaderContext'
import useEvents from '../hooks/useEvents'
import usePagination from '../hooks/usePagination'

const Events: React.FC = () => {
  const { setLoading: setPageLoading } = useContext(PageLoaderContext)
  const { events, apiLoading, apiError, apiLoadMore, apiLoadingMore } =
    useEvents()
  const { setTriggerElement } = usePagination(apiLoadMore)

  useEffect(() => {
    let didCancel = false

    if (didCancel) return

    setPageLoading(apiLoading)
    return () => {
      didCancel = true
    }
  })

  return (
    <Section>
      <EventList
        {...{
          events,
          apiError,
          apiLoading,
          apiLoadingMore,
          isCurrent: true,
          onTriggerElement: setTriggerElement,
        }}
      />
    </Section>
  )
}

export default Events
